export default __webpack_public_path__ + "static/media/button-confirm.41a4d902.svg";